import { useTranslation } from "react-i18next";

// 회사소개자료(국문) '주요 파트너사' 기준: 해운사 · 통신사 · 기자재 업체
const PARTNERS = [
  "PAN OCEAN",
  "STX OCEANSERVICE",
  "HANARO SHIPPING",
  "SK SHIPPING",
  "KMARIN",
  "DM MARITIME",
  "INTERGIS",
  "KDDI",
  "COMMUNIS",
  "MARINESECU",
  "KJ RADIO",
];

// 파트너사 띠(무한 흐름). compact: 홈용 — 제목 없이 작은 라벨만 붙여 소개 섹션 아래에 둠
export default function PartnersSection({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const items = [...PARTNERS, ...PARTNERS];

  return (
    <section id="partners" className={compact ? "py-10 overflow-hidden border-y border-background-200 bg-background-50" : "py-4 overflow-hidden"} data-reveal>
      {compact ? (
        <div className="text-center text-[11px] tracking-[0.35em] text-foreground-500 font-semibold uppercase font-label mb-6">
          Trusted by shipping companies &amp; partners
        </div>
      ) : (
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
            <div>
              <div className="text-xs tracking-[0.3em] text-foreground-500 font-semibold mb-2 uppercase">
                Trusted Partners
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {t("partners.title")}
              </h3>
            </div>
            <p className="text-sm text-foreground-600 max-w-md">
              {t("partners.desc")}
            </p>
          </div>
        </div>
      )}

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background-50 to-transparent z-10 pointer-events-none"></div>
        <div className="flex w-max animate-marquee">
          {items.map((p, i) => (
            <div
              key={i}
              className={
                compact
                  ? "flex-shrink-0 mx-8 flex items-center justify-center"
                  : "flex-shrink-0 mx-6 px-8 py-6 rounded-lg border border-background-200 bg-background-100 hover:border-primary-300 transition-colors min-w-[220px] flex items-center justify-center"
              }
            >
              <span
                className={
                  compact
                    ? "font-heading font-bold text-foreground-400 hover:text-foreground-800 transition-colors text-xl tracking-tight whitespace-nowrap"
                    : "font-heading font-bold text-foreground-700 text-lg tracking-tight whitespace-nowrap"
                }
              >
                {p}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
